import React ,{createRef }from "react";
import TeamMemberInfo from "./TeamMemberInfo";
import TeamMemberTerritoryInfo from "./TeamMemberTerritoryInfo";
import TeamMemberUploadDocInfo from "./TeamMemberUploadDocInfo";
import { browserHistory } from "react-router";
import CRUD from "../CRUD/CRUD";
import Drawer from "../Drawer";
import order from './order';
import { calculateYearsAndMonths, calculateNextBussinessDay, formattedDate, convertDateFormat,convertDateFormatYYYYMMDD, getCompanyName, checkUploadAccess, isAuthorizedUserForWebsiteChanges, sanitizeNotesForInput } from "../../utils";
import { ApolloConsumer } from "@apollo/client";
import { GET_HSC_MEMBER_LISTING_CLOSING_DATES, GET_STRIVE_AGENT_FIRST_LISTING } from "../Graphql/Queries/TeamMemberQuery";
import { GET_STRIVE_AGENT_PIPELINE_DETAILS_IN_TEAM_SCREEN } from "../Graphql/Queries/AgentPipelineQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_UPDATE_CONTACTS_TEAM_MEMBERS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_CONTACT_TEAM_BY_ID, GET_CONTACT_TEAM_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import { CREATE_TERRITORY_AGENT_MAP, DELETE_TERRITORY_AGENT_MAP, GET_TERRITORIES, GET_TERRITORY_AGENT_MAPING } from "../Graphql/Queries/FilterQuery";
import { GET_FILE_URL } from "../Graphql/Queries/getFileUrl";
import { UserContext } from "../Root/Root";
import TeamMemberWebsite from "./TeamMemberWebsite";
import cloneDeep from "lodash.clonedeep";
import { UPDATE_USER } from "../Graphql/Mutations/LoginMutation";
import NotesReusable from "../NotesReusable";
import UserInfo from "../userNew/UserInfo";
import { CREATE_USER } from "../Graphql/UserQueries/UserMutation";
import { GET_USER_BY_EMAIL_ID } from "../Graphql/UserQueries/userquaries";
import ReusableSpinner from "../ReactTable/ReusableSpinner";

const limit = 1000;

export default class CRUDTeamMember extends React.Component {
  drawerComponentRef;
  static get contextType() {
    return UserContext;
  }
  static createOptions({ id, status1, status2, isYtd = 0, orderBy }) {
    return {
      param: {
        agent_id: id,
        status_1: status1,
        status_2: status2 ? status2 : 'NOMATCH',
        is_ytd: isYtd
      },
      order: order(orderBy),
    };
  }
  static createOptionsWithoutOrder({ id, orderBy }) {
    return {
      param: {
        agent_id: id
      },
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      isExists: false,
      isDisabled: false,
      loggedInUserEmail: null,
      errorTabs: [],
      users: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      showDrawer: false,
      addNewItemType: null,
      resetDrawer: false,
      territoryMasterData:{},
      territoryCombinations:{},
      searchCrudFilter : false,
      filterData: [],
      currentIndex: 0,
      fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
      typeDuplicate:null,
      territory: [],
      removedTerritories: [],
      originalTerritories: [],
      errorIndex: [],
      isFormsLoading: false
    };
    this.client = null;
    this.notesRef = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.saveData = this.saveData.bind(this);
    this.addNewItem = this.addNewItem.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.token = localStorage.getItem('authToken');
    this.updateURL = this.updateURL.bind(this);
    this.addTerritory = this.addTerritory.bind(this);
    this.handleTerritoryChangeDropdown = this.handleTerritoryChangeDropdown.bind(this);
    this.removeTerritory = this.removeTerritory.bind(this);
    this.handleNotesChange = this.handleNotesChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id,nextProps.params.email);
    }
  }

  parseFilterOptions(query){
    const filterObject = {};
    if(query){
        for(const key in query){
            if(key !== 'order' && key !== 'page'){
                filterObject[key]= query[key]
            }
        }
    }
    return [filterObject]
}

  componentDidMount() {
    const userData = this.context;
    this.setState({ loggedInUserEmail: userData.userData && userData.userData.email });
    if (this.props.params.id === undefined) {
      let isDisabled = checkUploadAccess(userData.userData.email, null);
      this.setState({ isDisabled: isDisabled });
    }
    if (this.state.fromListUrl) {
      localStorage.setItem('fromListUrl', this.state.fromListUrl);
      this.setState({ fromListUrl: this.state.fromListUrl });
    }
    const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
    if(!hasQuery){
      this.fetch(this.props.params.id,this.props.params.email);
      this.fetchTerritoryMasterData();
    }
    if(hasQuery){
      this.setState({ searchCrudFilter: true });
      this.handleQueryChange();
      this.fetchTerritoryMasterData();
    }

  }


  fetchTerritoryMasterData(){
     /* 
     INFO:
     Instead of each time calling while saving pulled all 6000 records from master table but arc db allows only 1000 records per call
     and created a HASH for easy search 
     */
    fetchData(GET_TERRITORIES,)
      .then((res)=>{
      let territoryMasterData = {}
        if(res && res.data && res.data.getAllTerritories){
         res.data.getAllTerritories.forEach((val)=>{
            let key = val['market']+'#'+val['product_type']+'#'+val['territory'];
            territoryMasterData = {...territoryMasterData,[key]:{...territoryMasterData[key], [val['arcimedes_row_id']]:true}}
          })
        }
      this.setState({ territoryMasterData });
    })
  }

  componentDidUpdate(prevProps) {
  
    const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
    const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
    if (hasQuery && prevProps.location.search !== this.props.location.search) {
      this.handleQueryChange();
      this.fetchTerritoryMasterData();
      this.setState({ searchCrudFilter: true });
    }
    // Check if the query has changed
    // if (prevProps.location.search !== this.props.location.search) {
    //   this.handleQueryChange();
    // }
    if(!hasQuery && prevHasQuery){
      this.fetch(this.props.params.id,this.props.params.email);
      this.fetchTerritoryMasterData();
      this.setState({ searchCrudFilter: false });
    }
  }

  handleQueryChange() {
    const query = this.props.location.query;
    const filterOptions = this.parseFilterOptions(query); 
  
    var isNoFilter = Object.keys(filterOptions).length === 0; 
  
    if (isNoFilter) {
      this.fetch(this.props.params.id,this.props.params.email);
      this.fetchTerritoryMasterData();
    }
    else{
      this.fetchWithFilter(filterOptions)
      this.fetchTerritoryMasterData();
    }
  }

handleNotesChange(updatedNotes, editId) {
  const cleanedNotes = updatedNotes
    .filter((note) => note.text && note.text.trim() !== "")
    .filter((note) => {
      // Case 1: new note (no arcimedes_row_id)
      if (!note.arcimedes_row_id) return true;

      // Case 2: edited note (arcimedes_row_id matches editId)
      if (editId && note.arcimedes_row_id === editId) return true;

      // Case 3: deleted note
      if (note.deleted === 1) return true;

      // Skip everything else
      return false;
    })
    .map(
      ({
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
         date,
        ...rest
      }) => rest
    );

  this.setState((prev) => ({
    data: {
      ...prev.data,
      notes: cleanedNotes,
    },
  }));
}
  fetchWithFilter(filterOptions) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });
  
    fetchData(GET_CONTACT_TEAM_LIST_QUERY, { type:"Team",filters:filterOptions})
          .then(res => {
            const filterData = res.data.getContacts.data|| [];
            if(filterData.length > 0){
              // if (filterData) {
                let currentTeamMember = this.updateDateField(filterData[0]);
                let isDisabled = checkUploadAccess(this.state.loggedInUserEmail, currentTeamMember.email);
                this.setState({ isDisabled: isDisabled });
                this.fetchTerritory(currentTeamMember)
                // this.setState({
                //   data: currentTeamMember,
                //   original: { ...currentTeamMember },
                //   error: null,
                // });
              // } 
              this.setState({
                // items: res.data.getCompanies.data,
                // totalCount: res.data.getCompanies.totalCount,
                // error: null,
                // isBusy: null,
                filterData,
                currentIndex:0,
                data:  filterData[0],
                original: { ...filterData[0] },
                error: null,
              },() => {
                this.updateURL(filterData[0]);
              });
            }else {
              this.setState({
                filterData: [],
                data: false,
                error: "No filtered data found. Please try again with different filters.",
              });
            }
          })
          .catch((error) => {
            this.setState({
              data: false,
              error: error.message || "Unidentified Error",
            });
          });
      
  }

  closeDrawer() {
    this.setState({ showDrawer: false, resetDrawer: true });
  }

  fetchTerritory(data){
    /*
    INFO:
    Retriving the stored values from mapping table and suplied to dropdown and created the HASH(territoryCombinations)
    with list ARCIMEDES_ROW_ID, we can use this id's and HASH keys while soft deleting the rows and also to weather to update or not.
    --------------------
    */
   let currentTeamMember = data?data:this.state.data;
   fetchData(GET_TERRITORY_AGENT_MAPING,{agentId: parseInt(this.props.params.id)}).then((res) => {
      let territoryCombinations = {}
      // const markets = new Set();
      // const types = new Set();
      // const territorys = new Set();
      let tempTerritories = [];
      if (res && res.data && res.data.territoryAgentMappingData && res.data.territoryAgentMappingData.success && Array.isArray(res.data.territoryAgentMappingData.data)) {
        let data = res.data.territoryAgentMappingData.data
        data.forEach((val)=>{
          // markets.add(val.market)
          // types.add(val.product_type)
          // territorys.add(val.territory)

          let key = val.market+'#'+val.product_type+'#'+val.territory
          if(key in territoryCombinations){
            territoryCombinations={
              ...territoryCombinations,
              [key]:[...territoryCombinations[key],val.arcimedes_row_id]
            }
          }else{
            let temp = [val.arcimedes_row_id]
            territoryCombinations={
              ...territoryCombinations,
              [key]: temp
            }
            tempTerritories.push({
              market: val.market,
              type: val.product_type,
              territory: val.territory,})
          }
        })
      }
      // let market = '';
      // let type = '';
      // let territory = '';

      // markets.forEach((key)=>{market = market+','+key});
      // types.forEach((key)=>{type = type+','+key});
      // territorys.forEach((key)=>{territory = territory+','+key});

      // currentTeamMember['market'] = market;
      // currentTeamMember['type'] = type;
      // currentTeamMember['territory'] = territory;

      /* ---------------------------------------- */
      this.setState({          
        data: currentTeamMember,
        original: { ...currentTeamMember },
        originalTerritories: cloneDeep(tempTerritories),
        territory: tempTerritories,
        territoryCombinations,
        removedTerritories: [],
    })
});
}


  fetch(id) {
    this.setState({
   // data: null, we have comment this line to avoid loading symbol has ali dont want to be screen get change when value is null we was showing loader
      error: null,
      success: null,
    });

    if (id === undefined) {
      let data = {};
      data["is_agent"] = 'n';
      data["contact_type"] = ["Team"];
      data["status_code"] = "Active"
      this.setState({ data: data });
      return;
    }
    fetchData(GET_CONTACT_TEAM_BY_ID, { contactid: Number(id)})
    .then((result) => {
      
      // const teamData = result && result.data && result.data.getTeamMember;
       const teamData = result && result.data && result.data.getContactByContactid.contact;
      if (teamData) {
        let currentTeamMember = this.updateDateField(teamData);
        let isDisabled = checkUploadAccess(this.state.loggedInUserEmail, currentTeamMember.email);
        this.setState({ isDisabled: isDisabled });
        this.fetchTerritory(currentTeamMember)
        this.setState({
          data: currentTeamMember,
          original: { ...currentTeamMember },
          error: null,
        });
          if (currentTeamMember.email) {
          fetchData(GET_USER_BY_EMAIL_ID, { email: currentTeamMember.email })
            .then((res) => {
              if (res && res.data && res.data.getUser) {
                var userData = res.data.getUser;

                // Merge user info into existing data
                this.setState((prevState) => {
                  var updatedData = Object.assign({}, prevState.data);
                  updatedData.status_code = userData.status_code || "Active";
                  updatedData.user_type = userData.user_type || "";
                  updatedData.user_id = userData.id || "";
                  return { data: updatedData };
                });
              }
            })
            .catch((err) => {
              console.error("Error fetching user by email:", err);
            });
        }
      } else {
        this.setState({
          data: false,
          error: result.errors ? result.errors[0].message : "Unidentified Error",
        });
      }
    }).catch((error) => {
      this.setState({
        data: false,
        error: error.message || "Unidentified Error",
      });
    });
  }
  updateDateField(obj) {
    obj['starting_date'] = obj['starting_date'] ? formattedDate(obj['starting_date']) : null;
    obj['birth_date'] = obj['birth_date'] ? formattedDate(obj['birth_date']) : null;
    obj['on_phones'] = obj['on_phones'] ? formattedDate(obj['on_phones']) : null;
    obj['in_pool'] = obj['in_pool'] ? formattedDate(obj['in_pool']) : null;
    obj['first_listing'] = obj['first_listing'] ? formattedDate(obj['first_listing']) : null;
    obj['first_closing'] = obj['first_closing'] ? formattedDate(obj['first_closing']) : null;
    obj['termination_date'] = obj['termination_date'] ? formattedDate(obj['termination_date']) : null;

    return obj;
  }

  async fetchUserData(offset) {
    const limit = 50; // Ensure this limit is defined somewhere in your code
  
    try {
      const { data } = await fetchData(GET_CONTACT_TEAM_LIST_QUERY, { type:"Team",
        pageOptions: {
          page: offset + 1, 
          pageSize: limit,
        },
      })
  
      // Update the state with the fetched users
      this.setState(prevState => {
        // const users = prevState.users.concat(data.getTeamMembers.teamMember); 
        const users = prevState.users.concat(data.getContacts.data); 
        return { users };
      });
  
      if (data.getContacts.data.length >= limit) {
        this.fetchUserData(++offset);
      } else {
        const isExists = this.state.users.filter(u => 
          (this.state.data.arcimedes_row_id !== undefined && this.state.data.arcimedes_row_id !== null) ? 
          u.arcimedes_row_id !== this.state.data.arcimedes_row_id : true
        ).find((e) => {
          return (
            (e.first_name != null && e.first_name.toLowerCase()) === 
            (this.state.data.first_name != null && this.state.data.first_name.toLowerCase()) &&
            (e.last_name != null && e.last_name.toLowerCase()) === 
            (this.state.data.last_name != null && this.state.data.last_name.toLowerCase()) &&
            (e.cell_phone === this.state.data.cell_phone)
          );
        });
  
        this.setState({
          isExists: !!isExists,
        });
  
        // if (!isExists) { has discuss with chisti i removed this reason due to api calling twise
        //   this.setState({ viewMode: true }, () => this.saveData());
        // }
      }
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  }

  updateURL(data) {
    const queryParams = new URLSearchParams(this.props.location.search);
    // const name = queryParams.get("name");
    // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
    const newUrl = `/teamMember/${data.contact_id}?${queryParams.toString()}`;
    browserHistory.push(newUrl);
  }
  
  async handleSubmit(client,e) {
    e.preventDefault();
    this.setState({
      isExists:false,
      typeDuplicate:null
    });
    if (this.state.viewMode) this.setState({ viewMode: false });
   if (this.notesRef.current && this.notesRef.current.validateNotes) {
  const isValid = this.notesRef.current.validateNotes();
  if (!isValid){
      console.log("Stop submit: notes invalid");
     return;
  }
}

    if (
      !this.state.data.first_name ||
  !this.state.data.last_name ||
  !this.state.data.cell_phone ||
  !this.state.data.email
    ) {
      this.setState({ errorTabs: [0], success: null });
      return;
    } else {
      this.setState({ errorTabs: [] });
    }

    if (this.state.isBusy || this.state.viewMode === true) return;
    
    // Add a small delay to ensure any pending setState operations complete
    setTimeout(() => {
      this.setState({...this.state,  viewMode: true }, () => {
        this.saveData();
      });
    }, 100);
  }
  convertKeysToUpperCase(obj) {
    return Object.keys(obj).reduce((acc, key) => {
      const upperKey = key.toUpperCase();
  
      // Convert the value of AGENT_ID to an integer
      acc[upperKey] = upperKey === 'AGENT_ID' ? parseInt(obj[key], 10) : obj[key];
  
      return acc;
    }, {});
  }
  
  updateUserData(rowId) {
    const data = { ...this.state.data };
    var difference = data.starting_date ? calculateYearsAndMonths(new Date(data.starting_date)) : '';
    data.on_phones = data.starting_date ? calculateNextBussinessDay(new Date(data.starting_date), 90) : '';
    data.in_pool = data.starting_date ? calculateNextBussinessDay(new Date(data.starting_date), 270) : '';
    data.yrs_at_strive = difference;
    var BirthdayDifference = data.birth_date ? calculateYearsAndMonths(new Date(data.birth_date)) : '';
    data.age = BirthdayDifference;


    if (data.is_agent === 'h') {        //Get first closing and first listing date if the team member is hsc team member

      if(this.client){
          fetchData(GET_HSC_MEMBER_LISTING_CLOSING_DATES, {hscTeamMember: data.email})
          .then(res => {
            if (res.data && res.data.hscMemberListingClosingDates) {
              data.first_closing = res.data.hscMemberListingClosingDates[0] ? formattedDate(res.data.hscMemberListingClosingDates[0]['loan_closing_date']) : null;
              data.first_listing = res.data.hscMemberListingClosingDates[0] ? formattedDate(res.data.hscMemberListingClosingDates[0]['hsc_listed_date']) : null;
    
              this.setState({
                data: data
              });
            }
          });
      }
    } if (data.is_agent === 'n') {    
      this.setState({
        data: data
      });
    }else {
      const closedHistoricalOptions = CRUDTeamMember.createOptions({
        id:  data.arcimedes_row_id,//rowId,
        status1: 'Closed',
        orderBy: 'CLOSE_OF_ESCROW.desc'
      });
      const listingOptions = CRUDTeamMember.createOptionsWithoutOrder({
        id: data.arcimedes_row_id,//rowId,
        orderBy: 'LISTED_DATE .desc'
      });
      const closedYtdOptions = CRUDTeamMember.createOptions({
          id: data.arcimedes_row_id, //rowId,
          status1: 'Closed',
          isYtd: 1,
          orderBy: 'CLOSE_OF_ESCROW.asc'
      });
      const requests = [
        fetchData(GET_STRIVE_AGENT_PIPELINE_DETAILS_IN_TEAM_SCREEN, {params:this.convertKeysToUpperCase(closedHistoricalOptions.param), sortOptions:[{ field: "close_of_escrow", order: "DESC" }]}),
        fetchData(GET_STRIVE_AGENT_FIRST_LISTING,{agentId: listingOptions.param.agent_id}),
        fetchData(GET_STRIVE_AGENT_PIPELINE_DETAILS_IN_TEAM_SCREEN, {params:this.convertKeysToUpperCase(closedYtdOptions.param), sortOptions:[{ field: "close_of_escrow", order: "DESC" }]}),
      ];

      let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
      if (!agentName) {
        requests.push(
        fetchData(GET_CONTACT_TEAM_BY_ID,{ contactid: Number(rowId)  })
      )
      }

      Promise.all(requests).then(res => {
        if (res && res[0] && Array.isArray(res[0].data.getStriveAgentPipelineDetails) &&
          res && res[1] &&  Array.isArray(res[1].data.striveAgentFirstListing) &&
          res && res[2] &&  Array.isArray(res[2].data.getStriveAgentPipelineDetails)) {
          /* if (res[0]) {
            data.first_closing = res[0].data[0] ? formattedDate(res[0].data[res[0].data.length - 1].close_of_escrow) : null;
          }
          if (res[1]) {
            data.first_listing = res[1].data[0] ? formattedDate(res[1].data[0]['listed_date']) : null;
          } */
         let closedProperties;
          if( res[0].data.getStriveAgentPipelineDetails && res[0].data.getStriveAgentPipelineDetails.length > 0 && res[2].data.getStriveAgentPipelineDetails && res[2].data.getStriveAgentPipelineDetails.length > 0){
              closedProperties = [...res[0].data.getStriveAgentPipelineDetails,...res[2].data.getStriveAgentPipelineDetails];
          }else if(res[0].data.getStriveAgentPipelineDetails && res[0].data.getStriveAgentPipelineDetails.length > 0 &&  res[2].data.getStriveAgentPipelineDetails && res[2].data.getStriveAgentPipelineDetails.length === 0){
            closedProperties = [...res[0].data.getStriveAgentPipelineDetails];
          }else if( res[2].data.getStriveAgentPipelineDetails && res[2].data.getStriveAgentPipelineDetails.length > 0 && res[0].data.getStriveAgentPipelineDetails && res[0].data.getStriveAgentPipelineDetails.length === 0){
            closedProperties = [...res[2].data.getStriveAgentPipelineDetails];
          }
          if(closedProperties && closedProperties.length > 0){                
            const filteredData = closedProperties.filter(item => item.transaction_type !== "Referral");
            const result = filteredData.filter(property => {
              // Check listing agents
              if (
                  (property.listing_agent_1 == data.arcimedes_row_id && parseFloat(property.listing_agent_1_percent) >= 25) ||
                  (property.listing_agent_2 == data.arcimedes_row_id && parseFloat(property.listing_agent_2_percent) >= 25) ||
                  (property.listing_agent_3 == data.arcimedes_row_id && parseFloat(property.listing_agent_3_percent) >= 25)
              ) {
                  return true;
              }
          
              // Check buyer agents
              if (
                  (property.buyer_agent_1 == data.arcimedes_row_id && parseFloat(property.buyer_agent_1_percent) >= 25) ||
                  (property.buyer_agent_2 == data.arcimedes_row_id && parseFloat(property.buyer_agent_2_percent) >= 25) ||
                  (property.buyer_agent_3 == data.arcimedes_row_id && parseFloat(property.buyer_agent_3_percent) >= 25)
              ) {
                  return true;
              }
          
              return false;
          }).map(property => property.close_of_escrow);                
            const firstClosingDate = result.sort((a, b) => new Date(a) - new Date(b))[0];
            data.first_closing = firstClosingDate?convertDateFormat(firstClosingDate):"";
          }

          if (res && res[1] &&  Array.isArray(res[1].data.striveAgentFirstListing)) {
            const startDate = new Date(data.starting_date);
            const firstAfterStartDateObj = res[1].data.striveAgentFirstListing
            .map(item => ({ ...item, listed_date: new Date(item.listed_date) })) 
            .filter(item => item.listed_date > startDate) 
            .sort((a, b) => a.listed_date - b.listed_date) 
            .shift(); 

            data.first_listing = firstAfterStartDateObj && firstAfterStartDateObj.listed_date?convertDateFormat(firstAfterStartDateObj.listed_date):"";  
          } 
          //data[key] = query[key];
          this.setState({
            data: data
          });
        }
      });
    }
  }
handleChangeDropdown(query, queryType, x, key) {

  const userContactTypes = key === "contact_type" && query.contact_type.split(',').map(type => type.trim());

  if (key === "contact_type" && (userContactTypes.length > 1 || query.contact_type === "Team") && this.state.typeDuplicate) {
    const match = this.state.typeDuplicate.match(/for\s(.+?)\stype/i); // extract "Agent, Investor, Lender"
    const messageContactTypes = match ? match[1].split(',').map(type => type.trim()) : [];

    const hasMatch = userContactTypes.some(type => messageContactTypes.includes(type));
    if (!hasMatch) {
      this.setState({
        isExists: false,
        typeDuplicate: null,
        isBusy: false,
      });
    }
  }

  const data = { ...this.state.data };
  data[key] = query[key];

  // New condition: if status_code is "Inactive", set termination_date to today's date
 if (key === 'status_code') {
  if (query[key] === 'Inactive') {
    const today = new Date();
    const formattedDate = `${(today.getMonth() + 1).toString().padStart(2, '0')}/${today
      .getDate()
      .toString()
      .padStart(2, '0')}/${today.getFullYear()}`;
    data.termination_date = formattedDate;
  } else if (query[key] === 'Active') {
    // Clear termination date when status becomes Active
    data.termination_date = null;
  }
}

  this.setState({
    data: data
  });
}

  handleChangeFile(key, value) {
    this.setState(prevState => {
      const updatedData = { ...prevState.data };
      updatedData[key] = value;
      
      return {
        data: updatedData,
        success: null
      };
    });
  }
  handleChangeInput(key, value) {
    const data = { ...this.state.data };
    if (key === 'email') {
  const companyName = getCompanyName(value);

  if (["highstcapital", "athenacapitalre.com"].includes(companyName) && data.is_agent !== "e" && data.is_agent !== "i") {
    data.is_agent = "h";
  }
}
    if (key === 'starting_date') {
      let difference = calculateYearsAndMonths(new Date(value));
      data.on_phones = calculateNextBussinessDay(new Date(value), 90);
      data.in_pool = calculateNextBussinessDay(new Date(value), 270);
      data.yrs_at_strive = difference;
    }
    if (key === 'birth_date') {
      let difference = calculateYearsAndMonths(new Date(value));
      data.age = difference;
    }
    if(key === 'visible_on_website' || key === 'visible_on_bov'){
      data[key] = data[key] === 'y' ? null : 'y'
    }else{
      data[key] = value;
    }
    this.setState({
      success: null,
      data: data
    });
    if (data.first_name && data.last_name && data.cell_phone && data.email) {
      this.setState({
        errorTabs: []
      });
    } else if(!data.first_name && !data.last_name && !data.cell_phone && !data.email){
      this.setState({
        errorTabs: [0],
        isBusy : true
      });
    }
    
  }

  async triggerGetFileUrlForUploadedFiles(dataSource) {
    const fileFields = [
      'w9_form', 'w4_form', 'payroll_form', 'ca_form', 
      'it_policy_form', 'trade_secrets_form', 're_license_form'
    ];

    const validResults = [];
    
    for (const fieldName of fileFields) {
      if (dataSource[fieldName]) {
        try {
          const response = await fetchData(GET_FILE_URL, { id: dataSource[fieldName] });
          
          if (response.data && response.data.getFile && response.data.getFile.fileUrl) {
            const fileUrl = response.data.getFile.fileUrl;
            validResults.push({ fieldName, fileUrl });
          }
        } catch (error) {
          console.error(`Error retrieving file URL for ${fieldName}:`, error);
        }
      }
    }

    if (validResults.length > 0) {
      this.setState(prevState => {
        const updatedData = { ...prevState.data };
        
        validResults.forEach(({ fieldName, fileUrl }) => {
          updatedData[`${fieldName}_url`] = fileUrl;
        });
        
        return {
          data: updatedData,
          fileUrlsUpdated: Date.now(),
          isFormsLoading: false
        };
      });
    } else {
      this.setState({ isFormsLoading: false });
    }
  }

  saveData() {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
      isFormsLoading: true
    });
    // const convertedData = { ...this.state.data };
    if(this.state.data.termination_date != null){
      this.state.data.is_agent = this.state.data.is_agent,
      this.state.data.is_admin = "n",
      this.state.data.deleted = 1,
      this.state.data.visible_on_website = "n",
      this.state.data.visible_on_bov = "n"
    }
    const convertedData = {
      ...this.state.data,
    contact_type: Array.isArray(this.state.data.contact_type)   ? this.state.data.contact_type  : typeof this.state.data.contact_type === "string"  ? this.state.data.contact_type.split(",") : ["Team"],
    //...(this.state.data.contact_type.includes("Team") && {
      name: this.state.data.contact_type.includes("Lender") ? this.state.data.name : "",
      notes: sanitizeNotesForInput(this.state.data && this.state.data.notes),
    //})
    };
    
    // Apply date conversions to convertedData, not this.state.data
    convertedData.starting_date = convertedData.starting_date ? convertDateFormatYYYYMMDD(convertedData.starting_date) : null;
    convertedData.birth_date = convertedData.birth_date ? convertDateFormatYYYYMMDD(convertedData.birth_date) : null;
    convertedData.on_phones = convertedData.on_phones ? convertDateFormatYYYYMMDD(convertedData.on_phones) : null;
    convertedData.in_pool = convertedData.in_pool ? convertDateFormatYYYYMMDD(convertedData.in_pool) : null;
    convertedData.first_listing = convertedData.first_listing ? convertDateFormatYYYYMMDD(convertedData.first_listing) : null;
    convertedData.first_closing = convertedData.first_closing ? convertDateFormatYYYYMMDD(convertedData.first_closing) : null;
    convertedData.termination_date = convertedData.termination_date ? convertDateFormatYYYYMMDD(convertedData.termination_date) : null;
    convertedData.territory = convertedData.territory ? convertedData.territory.toString() : null;
    
    // Clean up unwanted fields
    delete convertedData.arcimedes_created;
    delete convertedData.arcimedes_created_by;
    delete convertedData.arcimedes_modified;
    delete convertedData.arcimedes_modified_by;
    delete convertedData.__typename;
    
    // Remove all *_url fields that were added for internal use (file URL caching)
    const urlFields = ['w9_form_url', 'w4_form_url', 'payroll_form_url', 'ca_form_url', 
                       'it_policy_form_url', 'trade_secrets_form_url', 're_license_form_url'];
    urlFields.forEach(field => {
      if (field in convertedData) {
        delete convertedData[field];
      }
    });
    
    // Also remove fileUrlsUpdated timestamp field
    delete convertedData.fileUrlsUpdated;
    
    if('hot_list' in convertedData){
      delete convertedData.hot_list 
    }
    const { status_code, user_type,password,user_id, ...filteredData } = convertedData;
    const userData = {  //userData payload
     status_code: convertedData.status_code || null,
     user_type: convertedData.user_type || null,
     password_hash: convertedData.password || null,
     username : convertedData.first_name + convertedData.last_name || "",
     email:convertedData.email || null,
      id:this.state.data.user_id || ""
     }; 

    return mutateData(CREATE_OR_UPDATE_CONTACTS_TEAM_MEMBERS, {input: filteredData})
    .then((result) => {
      const data = {...this.state.data};
      // const teamRes = result.data.createOrUpdateTeamMember.teamMember;
      const teamRes = result.data.createOrUpdateContact.contact;
      if(teamRes){
        // Use current state data instead of API response for file fields
        // because API response might not include file field values
        this.triggerGetFileUrlForUploadedFiles(this.state.data);
        
        data['starting_date'] = teamRes.starting_date ? formattedDate(teamRes.starting_date) : null;
          data['birth_date'] = teamRes.birth_date ? formattedDate(teamRes.birth_date) : null;
          data['on_phones'] = teamRes.on_phones ? formattedDate(teamRes.on_phones) : null;
          data['in_pool'] = teamRes.in_pool ? formattedDate(teamRes.in_pool) : null;
          data['first_listing'] = teamRes.first_listing ? formattedDate(teamRes.first_listing) : null;
          data['first_closing'] = teamRes.first_closing ? formattedDate(teamRes.first_closing) : null;
          data['termination_date'] = teamRes.termination_date ? formattedDate(teamRes.termination_date) : null;
          data['name'] = teamRes.name;
          data['notes'] = teamRes.notes;

          let index = [];
          /* 
          INFO:
          Checking weather we have records on master table with the given combination market producttype and territory
          */
          let territoryMapingData = [];
          // if((!this.state.original) || (this.state.original.market !== market) || (this.state.original.TYPE !== type) || (this.state.original.territory !== territory)){
          if((this.state.territory || this.state.originalTerritories) && !(_.isEqual(this.state.territory, this.state.originalTerritories))){
            let newKeys = [];
            // territory = territory && territory.replace(/^,|,$/g, '');
            // type = type && type.replace(/^,|,$/g, '');
            // market = market && market.replace(/^,|,$/g, '');
            // territory && territory.split(',').forEach(_territory => {
            //   type.split(',').forEach(_type => {
            //     market.split(',').forEach(_market => {
              this.state.territory.forEach(({ market: _market, type: _type, territory: _territory }, _index) => {
                  let key = _market+'#'+_type+'#'+_territory;
                  key = key.replaceAll(',','')
                  newKeys.push(key);
                  if(key in this.state.territoryMasterData){
                    if(!(key in this.state.territoryCombinations)){
                      Object.keys(this.state.territoryMasterData[key]).forEach((arcimedes_row_id)=>{
                        territoryMapingData.push({
                          territory_id: arcimedes_row_id,
                          agent_id: teamRes.contact_id
                        })
                      })
                    }
                  }else{
                    index.push( _index)
                  }
                })
            //     })
            //   })
            // })
            let shouldDeleteRows = [];
            // deleting the rows which are unselected
            Object.keys(this.state.territoryCombinations).forEach((key)=>{
              if(!(newKeys.includes(key))){
                shouldDeleteRows = [...shouldDeleteRows, ...this.state.territoryCombinations[key]]
              }
            })
            let deleteRows = []
            shouldDeleteRows.forEach(arcimedes_row_id => {
              deleteRows.push({
                arcimedes_row_id,
                deleted:1
              })
            });
            // updating the records in agent mapping creating/deleting
            // delete must finish before create/refetch, otherwise the refetch can
            // still see the old rows and the edited territory shows up twice
            if(index.length===0 && (deleteRows.length !== 0 || territoryMapingData.length !== 0)){
              const deletePromise = deleteRows.length !== 0
                ? mutateData(DELETE_TERRITORY_AGENT_MAP, {input: deleteRows})
                : Promise.resolve();
              deletePromise
                .then(() => territoryMapingData.length !== 0
                  ? mutateData(CREATE_TERRITORY_AGENT_MAP, {input: territoryMapingData})
                  : null)
                .then(() => {
                  if(!this.props.edit && territoryMapingData.length !== 0){
                    browserHistory.push({
                      pathname: `/teamMember/${teamRes.contact_id}/${teamRes.email}`,
                    });
                  }else{
                    this.fetchTerritory(data)
                  }
                })
                .catch((err) => console.error("Error updating territories:", err));
            }
          }
        if (
          Object.values(userData).some(
            (val) => val !== null && val !== "" && val !== undefined
          )
        ) {
          mutateData(CREATE_USER, {
            input: userData,
          })
            .then((res) => {
              const userDataResponse =
                res && res.data && res.data.createOrUpdateUser
                  ? res.data.createOrUpdateUser.user
                  : null;
               if (userDataResponse) {
                 this.setState((prevState) => ({
                   data: {
                     ...prevState.data,
                     status_code: userDataResponse.status_code
                       ? userDataResponse.status_code
                       : "",
                     user_type: userDataResponse.user_type
                       ? userDataResponse.user_type
                       : "",
                   },
                 }));
               }
            })
            .catch(function (err) {
              console.error("Error updating user:", err);
            });
        }
          if(this.state && this.state.original && this.state.original.termination_date == null && teamRes.termination_date != null){
            mutateData(UPDATE_USER, {userEmail: teamRes.email, input: {status_code: 'Inactive'}}).then((userResp)=>{})
          }
          if(index.length > 0){
            this.setState({
              data: data,
              original: cloneDeep(data),
              isBusy: null,
              error: "Please select valid territory.",
              errorIndex: index,
              isFormsLoading: false
            });
          }
          else{
          this.setState(
            {
              data: data,
              original: cloneDeep(data),  
              isBusy: false,
              success: "Saved",
              errorTabs: [],
              errorIndex: []
            },
            () => {
              if (!this.props.edit) {
                browserHistory.push({
                  pathname: `/teamMember/${teamRes.contact_id}/${teamRes.email}`,
                });
              }
            }
          );
          
        }

          window.scrollTo(0, 0);
        }   else if(result && result.data && result.data.createOrUpdateContact && result.data.createOrUpdateContact.error && result.data.createOrUpdateContact.error.includes("already exists")){
          
          this.setState({
          isExists:true,
          typeDuplicate: result.data.createOrUpdateContact.error,
          viewMode:false,
          isFormsLoading: false
        })
        }
        else {
          this.setState({
            isBusy: null,
            error: result && result.data.createOrUpdateContact.message ? result.data.createOrUpdateContact.message : "Unspecified error",
            isFormsLoading: false
          });
        }
      }).catch((error) => {
        this.setState({
          isBusy: false,
          error: error.message || "Unspecified error",
          isFormsLoading: false
        });
      });
  }



  toggleDrawer() {
    this.setState((prevState) => ({ showDrawer: !prevState.showDrawer, resetDrawer: false }));
  }

  addNewItem(addNewItemType) {
    this.setState({ addNewItemType }, this.toggleDrawer);
  }

  addTerritory () {
    this.setState((prevState) => prevState.territory.push({type:'', market:'', territory:''}));
  }

  removeTerritory (index) {
    this.setState((prevState) => {
      prevState.territory = prevState.territory.filter((item, _index) => _index !== index)
      prevState.removeTerritory = prevState.territory.filter((item, _index) => _index === index)
      return prevState
    });
  }

  handleTerritoryChangeDropdown(...rest) {
    const data = this.state.territory;
    data[rest[7]][rest[3]] = rest[0][rest[3]];
    if(rest[3] === 'type'){
      data[rest[7]]['market'] = '';
      data[rest[7]]['territory'] = '';
    }else if(rest[3] === 'market'){
      data[rest[7]]['territory'] = '';
    }
    this.setState({
      territory: data
    });
  }
  render() {
    const data = this.state.data;
    const { edit, isSuper } = this.props;
    let tabs = []
    if(data && data.is_agent && data.is_agent === 'n' && data.is_agent === 'e'){
      tabs = [
        {
          name: "TEAM MEMBER",
          renderedComponent: (
            <TeamMemberInfo
              data={data}
              isExists={this.state.isExists}
              handleChangeInput={this.handleChangeInput}
              handleChangeDropdown={this.handleChangeDropdown}
              viewMode={this.state.viewMode}
              deleted={data && data.deleted === "1"}
              addNewItem={this.addNewItem}
              handleParentDropdownChange={this.handleChangeDropdown}
              typeDuplicate={this.state.typeDuplicate}
            />

          ),
        },
          {
          name: "ISTRIVE",
          renderedComponent: (
            <UserInfo
              data={this.state.data}
              isExists={this.state.isExists}
              handleChangeInput={this.handleChangeInput}
              handleChangeDropdown={this.handleChangeDropdown}
              viewMode={this.state.viewMode}
              deleted={data && data.deleted === "1"}
              addNewItem={this.addNewItem}
              handleParentDropdownChange={this.handleChangeDropdown}
              typeDuplicate={this.state.typeDuplicate}
            />

          ),
        },
        {
          name: "Forms",
          renderedComponent: (
            <React.Fragment>
              {this.state.isFormsLoading && <ReusableSpinner />}
              <TeamMemberUploadDocInfo
                data={data}
                isDisabled={this.state.isDisabled}
                isExists={this.state.isExists}
                handleChangeInput={this.handleChangeInput}
                handleChangeFile={this.handleChangeFile}
                viewMode={this.state.viewMode}
                deleted={data && data.deleted === "1"}
                addNewItem={this.addNewItem}
              />
            </React.Fragment>
          ),
        }

      ]
    }else{
      tabs = [
        {
          name: "TEAM MEMBER",
          renderedComponent: (
            <TeamMemberInfo
              data={data}
              isExists={this.state.isExists}
              handleChangeInput={this.handleChangeInput}
              handleChangeDropdown={this.handleChangeDropdown}
              viewMode={this.state.viewMode}
              deleted={data && data.deleted === "1"}
              addNewItem={this.addNewItem}
              handleParentDropdownChange={this.handleChangeDropdown}
              typeDuplicate={this.state.typeDuplicate}
            />

          ),
        },
         {
          name: "ISTRIVE",
          renderedComponent: (
            <UserInfo
             data={data}
              isExists={this.state.isExists}
              handleChangeInput={this.handleChangeInput}
              handleChangeDropdown={this.handleChangeDropdown}
              viewMode={this.state.viewMode}
              deleted={data && data.deleted === "1"}
              addNewItem={this.addNewItem}
              handleParentDropdownChange={this.handleChangeDropdown}
              typeDuplicate={this.state.typeDuplicate}
            />

          ),
        },
...(data && data.is_agent !== "e" && data.is_agent !== "n" && data.is_agent !== "i"
  ? [
      {
        name: "TERRITORY",
        renderedComponent: (
          <TeamMemberTerritoryInfo
            data={data}
            isExists={this.state.isExists}
            handleChangeInput={this.handleChangeInput}
            handleChangeDropdown={this.handleChangeDropdown}
            viewMode={this.state.viewMode}
            deleted={data && data.deleted === "1"}
            addNewItem={this.addNewItem}
            addTerritory={this.addTerritory}
            territoryArray={this.state.territory}
            handleTerritoryChangeDropdown={this.handleTerritoryChangeDropdown}
            removeTerritory={this.removeTerritory}
            errorIndex={this.state.errorIndex}
          />
        ),
      },
    ]
  : []),

        {
          name: "Forms",
          renderedComponent: (
            <React.Fragment>
              {this.state.isFormsLoading && <ReusableSpinner />}
              <TeamMemberUploadDocInfo
                data={data}
                isDisabled={this.state.isDisabled}
                isExists={this.state.isExists}
                handleChangeInput={this.handleChangeInput}
                handleChangeFile={this.handleChangeFile}
                viewMode={this.state.viewMode}
                deleted={data && data.deleted === "1"}
                addNewItem={this.addNewItem}
              />
            </React.Fragment>
          ),
        }
      ]
    }
    if(isAuthorizedUserForWebsiteChanges(this.state.loggedInUserEmail)){
      tabs.push({
        name: "Website",
        renderedComponent: (
          <TeamMemberWebsite
            data={data}
            isDisabled={this.state.isDisabled}
            isExists={this.state.isExists}
            handleChangeInput={this.handleChangeInput}
            handleChangeFile={this.handleChangeFile}
            viewMode={this.state.viewMode}
            deleted={data && data.deleted === "1"}
            addNewItem={this.addNewItem}
          />

        ),
      })
    }
    if (
      data &&
      data.contact_type &&
      (Array.isArray(data.contact_type)
        ? data.contact_type.some((type) =>
            type
              .split(",")
              .some((t) => ["Agent","Lender", "Vendor", "Investor"].includes(t.trim()))
          )
        : data.contact_type
            .split(",")
            .some((t) => ["Agent","Lender", "Vendor", "Investor"].includes(t.trim())))
    ) {
      tabs.push({
        name: "Notes",
        renderedComponent: (
          <NotesReusable
           data={data}
            notes={data && data.notes ? data.notes : []}
            contact_id = {data && data.contact_id ? data.contact_id : null}
            viewMode={this.state.viewMode}
            handleChangeInput={this.handleChangeInput}
            ref={this.notesRef}
            //deleted={data && data.DELETED === "1"}
            deleted={data && data.deleted === "1"}
           setState={this.setState.bind(this)}
            onNotesChange={this.handleNotesChange}
            state={this.state}
          />
        ),
      });
    }
    
    return (
      <ApolloConsumer>
        {client => {
          if (!this.client) this.client = client;
          return (
            <React.Fragment>
              <CRUD
              tabsData={tabs}
              backLink={`${arc.path.base}contacts/team-members`}
              edit={edit}
              state={this.state}
              setState={this.setState.bind(this)}
              handleSubmit={this.handleSubmit.bind(this, client)}
              saveData={this.saveData}
              type="Team Member"
              backName="TEAM MEMBERS"
              title={data && `${data.first_name} ${data.last_name}`}
              isSuper={isSuper}
              filterData={this.state.filterData}
              currentIndex={this.state.currentIndex}
              updateURL={this.updateURL}
              // backToUrl={"teamMembers"}
              backToUrl={this.state.fromListUrl ? this.state.fromListUrl : "/teamMembers"}
              drawer={
                <Drawer
                  isOpen={this.state.showDrawer}
                  shouldDisplayChildDrawer={true}
                  reff={this.drawerComponentRef}
                  closeDrawer={this.closeDrawer}
                >
                </Drawer>
              }
            />
            </React.Fragment>
          )
        }}
      </ApolloConsumer>
    );
  }
}